export default "__VITE_ASSET__C_up4rsq__"